import { createSlice } from "@reduxjs/toolkit";

import { fetchGetRoles } from "./actions";
import { DataStatus } from "../../types";

type RolesState = {
  data: UserRole[];
  status: DataStatus;
  error: string | null;
};

const initialState: RolesState = {
  data: [],
  status: DataStatus.idle,
  error: null,
};

export const Slice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    resetRoles: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetRoles.pending, (state) => {
        state.status = DataStatus.loading;
        state.error = null;
      })
      .addCase(fetchGetRoles.fulfilled, (state, action) => {
        state.status = DataStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(fetchGetRoles.rejected, (state, action) => {
        state.status = DataStatus.failed;
        state.error = action.error.message ?? "";
      });
  },
});

export default Slice;
